import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["layer"];
  static values = { intensity: { type: Number, default: 0.35 } };

  connect() {
    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;

    this.onScroll = this.onScroll.bind(this);
    window.addEventListener("scroll", this.onScroll, { passive: true });
    this.onScroll();
  }

  disconnect() {
    window.removeEventListener("scroll", this.onScroll);
  }

  onScroll() {
    const offset = window.scrollY * this.intensityValue;

    this.layerTargets.forEach((layer, index) => {
      const speed = parseFloat(layer.dataset.parallaxSpeed || (0.15 + index * 0.1));
      const direction = layer.dataset.parallaxDirection === "up" ? -1 : 1;
      layer.style.transform = `translate3d(0, ${offset * speed * direction}px, 0)`;
    });
  }
}
